module.exports = __webpack_public_path__ + "static/media/small-arrow-blue.554487ed.svg";